import { useField } from "formik";
import React from "react";
import {
  Select,
  SelectProps,
  Textarea,
  TextareaProps,
  TextField,
  TextFieldProps,
} from "./fields";

type Named<P> = P & { name: string };

/** TextField bound to Formik; shows the Yup error after the field is touched. */
export const FormikTextField: React.FC<Named<TextFieldProps>> = ({
  name,
  ...rest
}) => {
  const [field, meta] = useField(name);
  return (
    <TextField
      {...field}
      value={field.value ?? ""}
      error={meta.touched && meta.error ? meta.error : undefined}
      {...rest}
    />
  );
};

export const FormikSelect: React.FC<Named<SelectProps>> = ({
  name,
  ...rest
}) => {
  const [field, meta] = useField(name);
  return (
    <Select
      {...field}
      value={field.value ?? ""}
      error={meta.touched && meta.error ? meta.error : undefined}
      {...rest}
    />
  );
};

export const FormikTextarea: React.FC<Named<TextareaProps>> = ({
  name,
  ...rest
}) => {
  const [field, meta] = useField(name);
  return (
    <Textarea
      {...field}
      value={field.value ?? ""}
      error={meta.touched && meta.error ? meta.error : undefined}
      {...rest}
    />
  );
};
